import Vue from "vue";
import Vuex from "vuex";
import DataanalysisTablesStore from "../app/dataanalysis/store";

Vue.use(Vuex);
const store = new Vuex.Store({
    namespaced: true,
    modules: {
        dataanalysisTablesStore: DataanalysisTablesStore,
    },
});

export default store;
